<template>
    <font-awesome-icon v-bind="props" :icon="getRegularFAIcon"/>
</template>

<script setup lang="ts">
import {computed} from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import type {IconDefinition} from "@fortawesome/pro-regular-svg-icons";


interface IconProps {
    icon: IconDefinition | string
    // Ensure the icon is loaded from all appropriate fontawesome packages that you might need (ex. solid, light, regular)
    packPrefix?: string | undefined
    [key: string]: any
}

const props = defineProps<IconProps>()
const getRegularFAIcon = computed<any>(() => {
    switch (typeof props.icon) {
        case "object":
            return {"icon": props.icon.icon, "prefix": props.packPrefix ?? "far", "iconName": props.icon.iconName}
        case "string":
            switch (props.icon) {
                case 'instagram':
                case 'facebook':
                case 'tiktok':
                case 'twitter':
                case 'youtube':
                case 'linkedin':
                    return ["fab", props.icon]
                case 'angle-left':
                case "arrow-left":
                case "arrow-up":
                case "arrow-right":
                case 'cart-plus':
                case 'circle':
                case "circle-question":
                case "cow":
                case "fill":
                case "flask-round-potion":
                case 'exclamation-triangle':
                case 'external-link-square-alt':
                case "play":
                case "quote-left":
                case "question":
                case 'rabbit':
                case 'star':
                case 'star-half':
                case "search":
                case "wheat":
                    return [props.packPrefix ?? "fas", props.icon]
                case "arrow-right-arrow-left":
                case "broadcast-tower":
                case "capsules":
                case "comment":
                case "coins":
                case "gift-card":
                case "inventory":
                case "mobile":
                case "paper-plane":
                case "pennant":
                case "user-circle":
                case "vial":
                    return [props.packPrefix ?? "fal", props.icon];
                case "microphone":
                    return [props.packPrefix ?? "far", props.icon];
                default:
                  return [props.packPrefix ?? "far", props.icon]
            }
    }
});

</script>